import React, { Component } from 'react';
import QRCode from 'qrcode.react';
import ReactToPrint from 'react-to-print'
import './QRCode.css';
import { FiPrinter } from 'react-icons/fi';

const lang = {
    en: 'QR Code',
    uz: 'QR Kod',
    ru: 'QR Kод',
}

class QR extends Component {
    render() {

        return (
            < div className="d-none d-print-flex text-center" style={styles.container} >
                {/* <QRCode value={`${this.props.data}`} renderAs="svg" style={{ ...styles.svg, marginBottom: '3%' }} className="product-qr" /> */}
                <QRCode value={`${this.props.data}`} renderAs="svg" style={styles.svg} className="product-qr" />
            </div >
        )
    }
}
class QRCodeComponent extends Component {
    state = { visible: true }
    render() {
        return (
            <div className="">
                <div style={{ display: this.state.visible ? 'flex' : 'none' }} id="print-area">
                    <QR data={this.props.data} ref={ref => this.printRef = ref} />
                    <ReactToPrint
                        trigger={() => <span className="d-print-none btn btn-outline-dark btn-sm" id="qr-code-btn">{lang[this.props.lang]} <FiPrinter className="p-0" /></span>}
                        content={() => this.printRef}
                    />
                </div>
            </div>
        );
    }
}
const styles = {
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
        flexDirection: "column",
        alignContent: "center",
        width: "90vw",
        height: "90vh",
        margin: "auto",
        // marginTop: '13%',
        textAlign: "center",
    },
    svg: {
        width: '80vw',
        border: '1px solid',
        height: '80vh',
        padding: '3%',
    }
}
export default QRCodeComponent;